import { SvgIconType } from './svg.interface';

const Search: SvgIconType = ({
  width = 12,
  height = 12,
  className = '',
  color = '#6A7383'
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.53006 8.46938C9.50477 8.44409 9.47812 8.42098 9.45034 8.40005C10.1094 7.5226 10.5 6.43191 10.5 5.25C10.5 2.35051 8.1495 0 5.25 0C2.35051 0 0 2.35051 0 5.25C0 8.1495 2.35051 10.5 5.25 10.5C6.43192 10.5 7.52262 10.1094 8.40008 9.45033C8.421 9.4781 8.44411 9.50475 8.4694 9.53004L10.7199 11.7806C11.0128 12.0735 11.4877 12.0735 11.7806 11.7806C12.0735 11.4877 12.0735 11.0128 11.7806 10.7199L9.53006 8.46938ZM9 5.25C9 7.32107 7.32107 9 5.25 9C3.17893 9 1.5 7.32107 1.5 5.25C1.5 3.17893 3.17893 1.5 5.25 1.5C7.32107 1.5 9 3.17893 9 5.25Z"
      fill={color}
    />
  </svg>
);

export default Search;
